export const SideBar = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <path d="M10.8334 16.0333L5.83337 10.2L10.8334 4.36667" stroke="#0E1726" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.5" d="M14.1665 16.0333L9.1665 10.2L14.1665 4.36667" stroke="#0E1726" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}